/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `jan` - jan
 * * `feb` - feb
 * * `mar` - mar
 * * `apr` - apr
 * * `may` - may
 * * `jun` - jun
 * * `jul` - jul
 * * `aug` - aug
 * * `sep` - sep
 * * `oct` - oct
 * * `nov` - nov
 * * `dec` - dec
 * @export
 */
export const FloodMonthEnum = {
  JAN: "jan",
  FEB: "feb",
  MAR: "mar",
  APR: "apr",
  MAY: "may",
  JUN: "jun",
  JUL: "jul",
  AUG: "aug",
  SEP: "sep",
  OCT: "oct",
  NOV: "nov",
  DEC: "dec",
} as const;
export type FloodMonthEnum = (typeof FloodMonthEnum)[keyof typeof FloodMonthEnum];

export function instanceOfFloodMonthEnum(value: any): boolean {
  for (const key in FloodMonthEnum) {
    if (Object.prototype.hasOwnProperty.call(FloodMonthEnum, key)) {
      if (FloodMonthEnum[key as keyof typeof FloodMonthEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function FloodMonthEnumFromJSON(json: any): FloodMonthEnum {
  return FloodMonthEnumFromJSONTyped(json, false);
}

export function FloodMonthEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FloodMonthEnum {
  return json as FloodMonthEnum;
}

export function FloodMonthEnumToJSON(value?: FloodMonthEnum | null): any {
  return value as any;
}

export function FloodMonthEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): FloodMonthEnum {
  return value as FloodMonthEnum;
}
